import React, {FC, useEffect} from 'react';
import {connect} from "react-redux";
import MixPage from "../components/Main/MixPage";
import {IMix} from "../constants/types";
import WrapperPreloader from "../components/WrapperPreloader";
import {getShareMIx, updateShareMix} from "../modules/Share";
import {AppStateType} from "../services/rootReducer";
import { useParams } from 'react-router-dom';

interface ISharedMix {
    mix: Array<IMix>,
    isLoading: boolean,
    updateShareMix: any,
    getShareMIx: any
}

const SharedMix: FC<ISharedMix> = ({
                                       isLoading,
                                       mix,
                                       getShareMIx,
                                       updateShareMix
                                   }) => {
    const { id } = useParams();
    useEffect(() => {
        getShareMIx(id);
        // eslint-disable-next-line
    },[]);

    return (
      <WrapperPreloader isLoading={isLoading}>
          <MixPage
              mix={mix[0]}
              handleLikeButton={updateShareMix}
              goToUrl="/main"
          />
      </WrapperPreloader>
    )
};

const mapStateToProps = (state: AppStateType) => ({
    isLoading: state.share.isLoading,
    mix: state.share.shareMix
});

const mapDispatchToProps = (dispatch: any) => ({
    getShareMIx: (id: number) => dispatch(getShareMIx(id)),
    updateShareMix: (id: number, isMixLiked: boolean) => dispatch(updateShareMix(id, isMixLiked)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SharedMix);

